import { gql } from "@apollo/client";

export const MARKET_PENETRATION_QUERY = gql`
  query marketPenetration(
    $companyFilters: CompanyFilter!
    $productIds: [Int]!
    $localizeInstalls: Boolean = true
    $companyMatchFile: CompanyMatchFilter
  ) {
    marketPenetration(
      companyFilters: $companyFilters
      productIds: $productIds
      localizeInstalls: $localizeInstalls
      companyMatchFile: $companyMatchFile
    ) {
      productId
      companyCount
    }
  }
`;

export interface MarketPenetration {
  companyCount: number;
  productId: number;
}

export interface MarketPenetrationPayload {
  marketPenetration: MarketPenetration[];
}
